import * as React from 'react';
import { memo } from 'react';
import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Rect,
  Stop,
  SvgProps,
} from 'react-native-svg';

const SvgImmigration = (props: SvgProps) => (
  <Svg width={48} height={48} viewBox="0 0 48 48" fill="none" {...props}>
    <Path
      d="M7.20623 21.3284C7.1312 20.5024 7.65673 19.7515 8.48309 19.6761C12.0879 19.2256 14.7916 16.0713 16.2935 12.6917C16.1435 13.1422 16.1435 13.5931 16.1435 14.0435L16.2935 18.3242C14.6412 20.2769 12.1629 22.1543 8.93361 22.6048C8.03221 22.6799 7.28128 22.0794 7.20623 21.3284Z"
      fill="#0A50A1"
    />
    <Path
      d="M25.606 31.6179L27.1829 36.4991L33.5664 44.3095C34.3174 45.2859 34.2423 46.7128 33.266 47.4638C32.2896 48.2898 30.8627 48.1398 30.1117 47.1634C23.0522 38.527 23.3527 38.9775 23.2776 38.752L23.6531 32.894C24.329 32.5939 25.0051 32.1434 25.606 31.6179Z"
      fill="#0A50A1"
    />
    <Path
      d="M32.3656 26.2098C32.6661 26.1348 32.9665 25.9844 33.1166 25.8343L35.1444 31.9924L37.0971 31.3165L36.6466 29.9647L38.6744 29.2887L39.1246 30.716L41.0773 30.1151C41.6028 29.965 42.1287 30.2651 42.2787 30.716L42.4288 31.2415C42.9547 31.0915 44.3815 31.0164 44.5317 31.4669L47.9863 42.1308C48.1364 42.5813 47.01 43.3323 46.5595 43.4826L46.6345 43.7831C46.7845 44.3086 46.4844 44.8345 46.0336 44.9845L45.2826 45.21L45.3576 45.4354C45.4327 45.7359 45.2826 46.1113 44.9821 46.2614C44.6817 46.3364 44.3062 46.1864 44.1562 45.8859L44.0811 45.6605L41.9783 46.3364L42.0533 46.5618C42.1283 46.8623 41.9783 47.2378 41.6778 47.3128C41.3774 47.3878 41.0019 47.2378 40.9269 46.9373L40.8518 46.7119L40.1009 46.9373C39.5753 47.0874 39.0494 46.8623 38.824 46.3364L34.5433 33.1942C34.4683 32.9688 34.4683 32.8188 34.5433 32.5933L32.3656 26.2098Z"
      fill="#26B9B0"
    />
    <Path
      d="M16.8194 4.28068C16.8194 6.64491 18.7359 8.56171 21.1001 8.56171C23.4644 8.56171 25.3808 6.64491 25.3808 4.28068C25.3808 1.9168 23.4644 0 21.1001 0C18.7359 0 16.8194 1.9168 16.8194 4.28068Z"
      fill="#0A50A1"
    />
    <Path
      d="M21.3256 9.38735C22.9025 9.31232 24.2544 10.0633 25.1557 11.2648C26.5826 12.7667 29.6618 16.3714 33.1916 23.3563C33.5671 24.1073 33.2666 25.0086 32.5156 25.3841C31.7647 25.7596 30.8633 25.4591 30.4878 24.7082C28.8355 21.4789 27.3336 19.0006 26.0568 17.1982L26.3572 27.7877C26.4323 29.9655 24.9304 31.8429 22.9026 32.2938L22.0012 45.8121C21.9261 47.0136 20.8747 47.99 19.5979 47.915C18.321 47.84 17.4201 46.7885 17.495 45.5117L18.4714 30.8675C17.7955 30.1165 17.3449 29.1401 17.3449 28.0137L16.9694 13.9696C16.8194 11.4913 18.7718 9.46349 21.3255 9.38843L21.3256 9.38735Z"
      fill="#0A50A1"
    />
    <Path
      d="M4.65355 29.7397H5.17908V22.5301H6.98144C7.28189 22.9056 7.65738 23.1311 8.10793 23.2811H5.9301V29.7397H11.3373V23.2811H9.38453C10.3609 23.1311 11.1869 22.9056 12.0129 22.5301H12.0879V29.7397H12.8389C13.5148 29.7397 14.0403 30.2652 14.0403 30.9411L14.041 44.2338C14.041 44.9097 13.5155 45.4352 12.8396 45.4352H12.5391V46.1862C12.7645 46.3362 12.9146 46.5617 12.9146 46.7871C12.9146 47.1626 12.5391 47.5381 12.1636 47.5381C11.7131 47.5381 11.4127 47.2376 11.4127 46.7871C11.4127 46.5617 11.5627 46.3366 11.7881 46.1862V45.4352H6.00551V46.1862C6.23094 46.3362 6.38099 46.5617 6.38099 46.7871C6.38099 47.1626 6.00551 47.5381 5.63003 47.5381C5.17952 47.5381 4.87906 47.2376 4.87906 46.7871C4.87906 46.5617 5.02912 46.3366 5.25455 46.1862V45.4352L4.65363 45.4356C3.9777 45.4356 3.45218 44.91 3.45218 44.2341L3.45183 30.8662C3.3768 30.2653 3.97762 29.7397 4.65355 29.7397Z"
      fill="#26B9B0"
    />
  </Svg>
);

const Memo = memo(SvgImmigration);
export default Memo;
